import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, throwError } from 'rxjs';

export const noAccessInterceptor: HttpInterceptorFn = (req, next) => {
	const _router = inject(Router);
	return next(req).pipe(
		catchError((error) => {
			if (error.status === 401) {
				_router.navigate(['/no-registered']);
				return EMPTY;
			} else if (error.status === 403 && error.error.error === 'Permission denied.') {
				_router.navigate(['/no-permission']);
				return EMPTY;

			}
			return throwError(() => error);
		})
	);
};
